"use strict";
exports.__esModule = true;
exports.SimpleFilterComponent = void 0;
var angular = require("angular");
require('./simple-filter.component.css');
var COMPONENT_NAME = 'smartorg.r6.reportOptions.simpleFilter';
function isEmpty(object) {
    return !object || object.length === 0;
}
var SimpleFilterComponent = /** @class */ (function () {
    function SimpleFilterComponent() {
    }
    SimpleFilterComponent.prototype.$onInit = function () {
        this.filterType = (this.initState && this.initState.key) ? 'numerical' : 'categorical';
    };
    SimpleFilterComponent.prototype.$onChanges = function (changesObj) {
        if (changesObj.categories) {
            this.loadCategories();
        }
        if (changesObj.numericObjects) {
            this.loadNumericObjects();
        }
        if (changesObj.categories || changesObj.numericObjects || changesObj.initState) {
            this.loadState();
        }
    };
    SimpleFilterComponent.prototype.loadCategories = function () {
        if (isEmpty(this.categories)) {
            this.allCategories = [];
            return;
        }
        this.allCategories = angular.copy(this.categories);
        this.allCategories.forEach(function (cate) {
            cate.entries.forEach(function (entry) {
                entry.selected = true;
            });
        });
    };
    SimpleFilterComponent.prototype.loadNumericObjects = function () {
        if (isEmpty(this.numericObjects)) {
            this.allNumericObjects = [];
            return;
        }
        this.allNumericObjects = angular.copy(this.numericObjects);
        this.operators = [
            { display: '>', value: '$gt' },
            { display: '>=', value: '$gte' },
            { display: '=', value: '$eq' },
            { display: '<=', value: '$lte' },
            { display: '<', value: '$lt' },
        ];
    };
    SimpleFilterComponent.prototype.loadState = function () {
        var _this = this;
        if (isEmpty(this.categories)) {
            this.allCategories = [];
        }
        if (isEmpty(this.numericObjects)) {
            this.allNumericObjects = [];
        }
        if (!this.initState) {
            this.setFilterItemNull();
        }
        else if (this.initState.name && this.initState.entries) {
            this.filterType = 'categorical';
            this.selectedCategory = this.allCategories.find(function (cate) {
                return cate.name === _this.initState.name;
            });
            var selectedEntryNames_1 = this.initState.entries.filter(function (en) { return en.selected; }).map(function (en) { return en.name; });
            if (this.selectedCategory) {
                this.selectedCategory.entries.forEach(function (en) {
                    en.selected = selectedEntryNames_1.some(function (name) { return name === en.name; });
                });
            }
        }
        else if (this.initState.key && this.initState.field && this.initState.operator && typeof this.initState.value === 'number') {
            this.filterType = 'numerical';
            this.selectedNumericObject = this.allNumericObjects.find(function (numObj) {
                return numObj.key === _this.initState.key;
            });
            if (this.selectedNumericObject) {
                this.selectedNumericObject.operator = this.initState.operator;
                this.selectedNumericObject.value = this.initState.value;
                this.selectedNumericObject.template = this.initState.template;
            }
        }
    };
    SimpleFilterComponent.prototype.setFilterItemNull = function () {
        var filterType = this.filterType;
        if (!filterType) {
            this.selectedCategory = null;
            this.selectedNumericObject = null;
        }
        else if (filterType == 'categorical') {
            this.selectedCategory = null;
        }
        else if (filterType == 'numerical') {
            this.selectedNumericObject = null;
        }
    };
    // -------------------------------------------
    // Categorical Filter Methods
    SimpleFilterComponent.prototype.onCategoryChange = function (category) {
        if (category && category.entries) {
            category.entries.forEach(function (en) { return en.selected = true; });
        }
        this.updateFilter({ newVal: category });
    };
    SimpleFilterComponent.prototype.selectAll = function () {
        if (this.selectedCategory && this.selectedCategory.entries) {
            this.selectedCategory.entries.forEach(function (entry) { return entry.selected = true; });
        }
        this.updateFilter({ newVal: this.selectedCategory });
    };
    SimpleFilterComponent.prototype.invertSelect = function () {
        if (this.selectedCategory && this.selectedCategory.entries) {
            this.selectedCategory.entries.forEach(function (entry) { return entry.selected = !entry.selected; });
        }
        this.updateFilter({ newVal: this.selectedCategory });
    };
    SimpleFilterComponent.prototype.onEntrySelect = function (category) {
        this.updateFilter({ newVal: category });
    };
    // -------------------------------------------
    // Numerical Filter Methods
    SimpleFilterComponent.prototype.onNumericObjectChange = function (numericObject) {
        // this.updateFilter({newVal: numericObject});
        this.checkNumericFilterChangedItem('value');
    };
    SimpleFilterComponent.prototype.checkNumericFilterChangedItem = function (changedItem) {
        if (!this.selectedNumericObject) {
            console.log('No Valid Numerical Filter Item Selected!');
            this.updateFilter({ newVal: null });
            return;
        }
        var _a = this.selectedNumericObject, operator = _a.operator, value = _a.value, min = _a.min, max = _a.max;
        this.showNumericalOperatorWarning = !operator;
        this.showNumericalValueWarning = typeof value !== 'number';
        if (operator && (typeof value === 'number') && !this.isValidNumericFilter(this.selectedNumericObject)) {
            this.showNumericalOperatorWarning = changedItem === 'operator';
            this.showNumericalValueWarning = changedItem === 'value';
        }
        this.updateFilter({ newVal: this.selectedNumericObject });
    };
    SimpleFilterComponent.prototype.isValidNumericFilter = function (numericObject) {
        var operator = numericObject.operator, value = numericObject.value, min = numericObject.min, max = numericObject.max;
        if (!operator || typeof value !== 'number') {
            return false;
        }
        return (operator == '$gt' && value < max) ||
            (operator == '$gte' && value <= max) ||
            (operator == '$eq' && value <= max && value >= min) ||
            (operator == '$lte' && value >= min) ||
            (operator == '$lt' && value > min);
    };
    return SimpleFilterComponent;
}());
exports.SimpleFilterComponent = SimpleFilterComponent;
angular.module(COMPONENT_NAME, []).component("simpleFilter", {
    template: require("./simple-filter.component.html"),
    bindings: {
        title: '@',
        categories: '<',
        numericObjects: '<',
        initState: '<',
        showDelete: '<',
        updateFilter: '&',
        removeFilter: '&?',
        showAlert: '&?'
    },
    controller: SimpleFilterComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=simple-filter.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/report-options2/simple-filter/simple-filter.component.js